import { Loader, router } from 'routes'
import { Toast } from 'hooks/useToast'
import { RouterProvider } from 'react-router'
import { Suspense, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState, setOnline } from 'config/user/store'
import { useGetLanguages } from 'api/Settings/GlobalLanguages/globalLanguages'
import { setLanguages, setLoading } from 'config/user/store/languagesSlice'
import { useGetMe } from 'api/Authentication/getMe'
import { loginSuccess } from 'config/user/store/authSlice'
import NetworkErrorPage from 'components/networkError'

const App = () => {
  const dispatch = useDispatch()
  const online = useSelector((state: RootState) => state.networkError.online)

  const isAuthenticated = useSelector(
    (state: RootState) => state.auth.isAuthenticated
  )
  const auth = useSelector((state: RootState) => state.auth)
  const { data: getLanguage, isLoading } = useGetLanguages({
    enabled: isAuthenticated,
  })

  const { data } = useGetMe(isAuthenticated)

  useEffect(() => {
    if (window.location.hostname.includes('configurator')) {
      const url = new URL(window.location.href)
      const updatedHostname = url.hostname.replace('configurator', 'coreflex')
      url.hostname = updatedHostname
      window.location.href = url.toString()
    }
  }, [])

  useEffect(() => {
    dispatch(setLoading(isLoading))
  }, [isLoading, dispatch])

  useEffect(() => {
    if (getLanguage?.data) {
      dispatch(setLanguages(getLanguage.data))
    }
  }, [getLanguage?.data, dispatch])

  useEffect(() => {
    if (isAuthenticated && data?.data?.user!) {
      const authUser = {
        user: data?.data.user!,
        token: auth.Authorization!,
      }
      dispatch(loginSuccess(authUser))
    }
  }, [data, dispatch, isAuthenticated, auth.Authorization])

  useEffect(() => {
    const updateOnlineStatus = () => dispatch(setOnline(navigator.onLine))

    window.addEventListener('online', updateOnlineStatus)
    window.addEventListener('offline', updateOnlineStatus)

    // Call once to set initial state
    updateOnlineStatus()

    return () => {
      window.removeEventListener('online', updateOnlineStatus)
      window.removeEventListener('offline', updateOnlineStatus)
    }
  }, [dispatch])

  if (!online) {
    return <NetworkErrorPage />
  }

  return (
    <>
      <Suspense fallback={<Loader />}>
        <RouterProvider
          router={router}
          fallbackElement={<div>loading...</div>}
        />
      </Suspense>
      <Toast className="toastContainer" />
    </>
  )
}

export default App
